import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../../default-settings-service.service';

@Component({
  selector: 'audit-waffle',
  templateUrl: './audit-waffle.component.html',
  styles: []
})
export class AuditWaffleComponent extends ExcTranslation implements OnInit {

  @Input('Audit') Audit;
  constructor(private excDss: DefaultSettingsService) {
   super();
  }

  ngOnInit() {
  }
  getAuditStatus() {
    if (this.Audit.AuditType === 16 || this.Audit.AuditType === 35) {
      if (this.Audit.AuditState === 8 || this.Audit.AuditState === 9) {
         if (this.Audit.ScRejected === true) {
           return this.getGlobal('AuditState_13');
         } else {
           if (this.Audit.AuditPartialResults === true) {
             return this.getGlobal('AuditState_14');
           }
           if (this.Audit.AuditIsExpired === true) {
             return this.getGlobal('AuditState_12');
           }
         }
      }
    }
    return this.getGlobal('AuditState_' + this.Audit.AuditState);
  }

  getEnumerationStornoGrund(): any[] {
    return this.excDss.Enumeration.filter((enm: any) => enm.enmName === 'enum_Stornogrund');
  }

  getStornoGrund() {
    if (this.Audit.Auftr_F_Storniert && this.Audit.Auftr_StornoGrund) {
      const stornoGrund = this.getEnumerationStornoGrund();
      const stornoGrundElement = stornoGrund.find((grund: any) => grund.enmIdent === this.Audit.Auftr_StornoGrund);
      return `(${this.translateService.currentLang === 'en' ? stornoGrundElement.enmTextEN : stornoGrundElement.enmText})`;
    }
    return '';
  }
}
